import React, { Component } from "react";
import request, { client } from "../../api/api";
import queryString from "query-string";
import "./style.scss";
import jwt_decode from "jwt-decode";

export class Loader extends Component {
    
    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        if (parsed && parsed.au) {
            localStorage.removeItem("APUSEC");
            
            request({
                url: "/recruitment/candidate/actascandidates",
                method: "POST",
                data: { auth: parsed.au }
            })
                .then(res => {
                    if (res.status === 1) {
                        localStorage.setItem("APUSEC", res.response.auth_token);
                        client.defaults.headers.common["Authorization"] = res.response.auth_token;
                        this.props.history.replace("/dashboard/default");
                    } else if (res.status === 0) {
                        // toast.error(res.response);
                        // window.location = "/";
                    }
                })
                .catch(err => {
                    console.log("err->", err);
                });
        }
        const tokenCandidate = localStorage.getItem("APUSEC");
        if (tokenCandidate) {
            const token = jwt_decode(tokenCandidate);
            if (token && token.role) {
                switch (token.role) {
                    case "candidate":
                        this.props.history.replace("/dashboard/default");
                        break;
                    default:
                }
            }
        }
    }

    
    render() {
        return (
            <div id="spinner_loader" class="container_loader">
                <div class="site-loader">
                    <img
                        src="https://www.getshifts.co.uk/uploads/agency-portal-original.gif"
                        alt="loader"
                    />
                </div>
            </div>
        );
    }
}

export default Loader;
